import axios from "axios";
import httpClient from "./httpClient";

export const charts = {
	fetch: async (source) => {
		const response = await httpClient.post(source);
		return response.data;
	},
	apexdata: async (source) => {
		const response = await httpClient.get(source);
		return response.data;
	}
};
